// ─────────────────────────────────────────────────────────────
// LoopBuilderCatalogView — list of published loop-builder items.
// v1 stub: shows a placeholder until the catalog view is built.
// ─────────────────────────────────────────────────────────────

import {createElement} from "@opendaw/lib-jsx"
import {Lifecycle} from "@opendaw/lib-std"
import {StudioService} from "@/service/StudioService.ts"

type Construct = {lifecycle: Lifecycle; service: StudioService}

export const LoopBuilderCatalogView = ({}: Construct) => (
    <div className="st-section st-empty">
        <div>Loop Builder catalog</div>
        <div>Listing of published loop builder items will live here.</div>
    </div>
)
